export const blockIconsHomeCurtains = (
	<span className='material-symbols-outlined'>curtains</span>
);
